import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

export const getEventLocations = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/event-location`);
    return response.data;
  } catch (error) {
    console.error('Error fetching event locations:', error.response?.data || error);
    throw error;
  }
};

export const getEventLocationById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/event-location/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching event location:', error.response?.data || error);
    throw error;
  }
};

export const createEventLocation = async (data) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/event-location`, data);
    return response.data;
  } catch (error) {
    console.error('Error creating event location:', error.response?.data || error);
    throw error;
  }
};

export const updateEventLocation = async (id, data) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/event-location/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating event location:', error.response?.data || error);
    throw error;
  }
};

export const deleteEventLocation = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/event-location/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting event location:', error.response?.data || error);
    throw error;
  }
};
